@use "../../styles/breakpoint.module.scss" as *;

.root {
    visibility: inherit;
}

.match {
    composes: root;
    composes: match from "../../styles/theming.module.css";
}

.contrast {
    composes: root;
    composes: contrast from "../../styles/theming.module.css";
}

.grid {
    composes: gridContainer from "../../styles/composable/layout.module.css";
}

.header {
    background: var(--color-primary);

    @media ($above-mobile) {
        position: sticky;
        top: calc(var(--scroll-nav-menu-block-height, 0) + var(--spacer-40));
        align-self: start;
        grid-column: 1 / span 4;
    }

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }
}

.images {
    grid-column: 6 / span 7;

    @media ($below-mobile) {
        display: none;
    }
}

.item {
    &:not(:last-child) {
        margin-bottom: var(--spacer-80);
    }
}

.media {
    display: block;
    position: relative;
    width: 100%;
    height: auto;
    aspect-ratio: 4 / 3;
    overflow: hidden;

    @media ($below-mobile) {
        aspect-ratio: 284 / 240;
    }

    & :is(img, video) {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        object-fit: cover;
    }
}

.richText {
    margin-top: var(--spacer-8);

    & :is(p, li) {
        font: var(--font-p-16);
    }
}

.nav {
    display: none;
}

.carousel {
    grid-column: 1 / -1;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }

    @media ($above-mobile) {
        display: none;
    }
}

.listItem {
    --slides-visible: var(--slides-visible-mobile);
    --gutters: calc(var(--slides-visible) - 1);
    --gutter-width: var(--spacer-32);
    --gutter-space: calc(var(--gutter-width) * var(--gutters));
    --width: calc((100% - var(--gutter-space)) / var(--slides-visible));

    width: var(--width);
    margin-right: var(--gutter-width);
    vertical-align: top;

    &:last-child {
        margin-right: 0;
    }
}

.progressBar {
    position: relative;
    grid-column: 1 / -1;
    height: 2px;
    background: linear-gradient(
        90deg,
        var(--color-contrast) var(--scroll-progress-percent),
        rgb(var(--color-contrast-base) / 20%) var(--scroll-progress-percent)
    );

    @media ($above-mobile) {
        display: none;
    }
}
